'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002425 from "./presto.-Agent-View$$anon$25.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002427 from "./presto.-Agent-View$$anon$27.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$24() {
  this.axQ = null;
  this.axI = null;
  this.axJ = false;
  this.axR = null;
  this.axS = false;
  this.axV = null;
  this.axO = null;
  this.axP = false;
  this.axK = null;
  this.axL = false;
  this.axM = null;
  this.axN = false;
  this.axT = false;
  this.axU = false;
  this.axQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axV = "LocalPjeOfficeSignFileBase64Request";
}
export { $c_Lpresto_AgentView$$anon$24 as $c_Lpresto_AgentView$$anon$24 };
$p = $c_Lpresto_AgentView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$24;
/** @constructor */
function $h_Lpresto_AgentView$$anon$24() {
}
export { $h_Lpresto_AgentView$$anon$24 as $h_Lpresto_AgentView$$anon$24 };
$h_Lpresto_AgentView$$anon$24.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.axQ;
});
$p.L = (function() {
  if ((!this.axJ)) {
    this.axI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axJ = true;
  }
  return this.axI;
});
$p.O = (function() {
  if ((!this.axS)) {
    this.axR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axS = true;
  }
  return this.axR;
});
$p.E = (function() {
  return this.axV;
});
$p.t = (function() {
  if ((!this.axP)) {
    this.axO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axP = true;
  }
  return this.axO;
});
$p.M = (function() {
  if ((!this.axL)) {
    this.axK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002425.$c_Lpresto_AgentView$$anon$25())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axL = true;
  }
  return this.axK;
});
$p.Q = (function() {
  if ((!this.axN)) {
    this.axM = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002427.$c_Lpresto_AgentView$$anon$27();
    this.axN = true;
  }
  return this.axM;
});
$p.w = (function() {
  if ((!this.axU)) {
    this.axT = false;
    this.axU = true;
  }
  return this.axT;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee180) => ((p) => \u03b4scrutinee180.cFV(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$())));
});
var $d_Lpresto_AgentView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$24, "presto.AgentView$$anon$24", ({
  DO: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$24 as $d_Lpresto_AgentView$$anon$24 };
//# sourceMappingURL=presto.-Agent-View$$anon$24.js.map
